// extracted by mini-css-extract-plugin
module.exports = {"container":"articleDetail_container__3OwmY","breadcrumbBox":"articleDetail_breadcrumbBox__1VEPt"};